import { useTranslation } from 'react-i18next';

import type { DSPData } from '../../mockData/mockData';
import { BarChartTooltip } from '../BarChartTooltip';
import type { StreamType } from '../TrackStreamsGraph/TrackStreamsGraph';
import { DSPIcon } from './DSPIcon';

interface DSPTooltipProps {
  dsp: string;
  data: DSPData;
  totalStreams: number;
  streamType: StreamType;
}

export function DSPTooltip(props: DSPTooltipProps) {
  const { t } = useTranslation('names');
  return (
    <BarChartTooltip
      header={
        <>
          <DSPIcon type={props.dsp} className="w-lg" />
          {t(props.dsp)}
        </>
      }
      {...props}
    />
  );
}

DSPTooltip.displayName = 'DSPTooltip';
